const dict = {
  uk: {
    // AlertModal
    alertDefaultTitle: 'Повідомлення',
    // ConfirmModal
    confirmDefaultTitle: 'Підтвердження',
    confirm: 'Підтвердити',
    cancel: 'Скасувати',
    // ReferralModal
    referralTitle: 'Запросити друга',
    referralBonusPart1: 'Коли друг, зареєстрований за Вашим посиланням, уперше поповнить рахунок на суму від ',
    referralBonusPart2: ' протягом ',
    referralBonusPart3: ' після реєстрації, Ви отримаєте ',
    referralBonusPart4: ' бонусу, а Ваш друг — ',
    referralBonusPart5: ' на свій рахунок.',
    referralMinAmount: '500 грн',
    referralDaysPeriod: '30 днів',
    referralBonusAmount: '50 грн',
    referralBonusAmountExtra: 'ще 50 грн',
    yourReferralLink: 'Ваше реферальне посилання',
    loading: 'Завантаження…',
    copied: 'Скопійовано!',
    copy: 'Копіювати',
    share: 'Поділитися',
    invitedFriends: 'Запрошені друзі ({{count}})',
    statusPaid: 'Виплачено',
    statusPending: 'Очікує',
    statusExpired: 'Згорів',
    bonusCreditedOn: 'Бонус нараховано {{date}}',
    bonusCredited: 'Бонус нараховано',
    expiresOn: 'Згорить {{date}}',
    awaitingFirstDeposit: 'Очікує першого поповнення',
    friendDidNotDeposit: 'Друг не поповнив рахунок вчасно',
    noReferralsYet: 'Ще немає запрошених друзів',
    shareTitle: 'Приєднуйся до Lingvish!',
    shareText: 'Вивчай англійську разом зі мною на платформі Lingvish!',
    starsLessonDone: 'Урок завершено!',
    starsPerfect: 'Ідеальний урок!',
    starsGreat: 'Чудова робота!',
    starsGood: 'Молодець!',
    starsNice: 'Хороший старт!',
    starsProgress: 'Є прогрес!',
    starsNextTime: 'Наступного разу вийде!',
    starsCorrect: 'Правильно',
    starsCorrectOf: '{{earned}} з {{total}}',
    starsOne: 'зірка',
    starsMany: 'зірок',
    starsToProfile: '+{{count}} {{noun}} у профіль',
    starsRateLesson: 'Оцініть урок',
    starsRateSubtitle: 'Ваш відгук допоможе покращити навчання',
    starsCommentPlaceholder: "Коментар (необов'язково)",
    starsSkip: 'Пропустити',
    starsSubmit: 'Надіслати',
  },
  en: {
    // AlertModal
    alertDefaultTitle: 'Notification',
    // ConfirmModal
    confirmDefaultTitle: 'Confirmation',
    confirm: 'Confirm',
    cancel: 'Cancel',
    // ReferralModal
    referralTitle: 'Invite a friend',
    referralBonusPart1: 'When a friend who registers using your link makes their first deposit of at least ',
    referralBonusPart2: ' within ',
    referralBonusPart3: ' of registration, you will receive a ',
    referralBonusPart4: ' bonus, and your friend will get ',
    referralBonusPart5: ' on their account.',
    referralMinAmount: 'UAH 500',
    referralDaysPeriod: '30 days',
    referralBonusAmount: 'UAH 50',
    referralBonusAmountExtra: 'another UAH 50',
    yourReferralLink: 'Your referral link',
    loading: 'Loading…',
    copied: 'Copied!',
    copy: 'Copy',
    share: 'Share',
    invitedFriends: 'Invited friends ({{count}})',
    statusPaid: 'Paid',
    statusPending: 'Pending',
    statusExpired: 'Expired',
    bonusCreditedOn: 'Bonus credited on {{date}}',
    bonusCredited: 'Bonus credited',
    expiresOn: 'Expires on {{date}}',
    awaitingFirstDeposit: 'Awaiting first deposit',
    friendDidNotDeposit: 'Friend did not deposit in time',
    noReferralsYet: 'No invited friends yet',
    shareTitle: 'Join Lingvish!',
    shareText: 'Learn English with me on the Lingvish platform!',
    starsLessonDone: 'Lesson complete!',
    starsPerfect: 'Perfect lesson!',
    starsGreat: 'Great work!',
    starsGood: 'Well done!',
    starsNice: 'Good start!',
    starsProgress: 'Nice progress!',
    starsNextTime: 'Next time!',
    starsCorrect: 'Correct',
    starsCorrectOf: '{{earned}} of {{total}}',
    starsOne: 'star',
    starsMany: 'stars',
    starsToProfile: '+{{count}} {{noun}} to profile',
    starsRateLesson: 'Rate the lesson',
    starsRateSubtitle: 'Your feedback helps us improve',
    starsCommentPlaceholder: 'Comment (optional)',
    starsSkip: 'Skip',
    starsSubmit: 'Submit',
  },
};

export default dict;
